module.exports = __webpack_public_path__ + "fontawesome-webfont.acf3dcb7ff752b5296ca.svg";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-awesome/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../../src/assets/fonts/font-awesome/fontawesome-webfont.svg?v=4.7.0
// module chunks = 40